// extracted by mini-css-extract-plugin
export default {"wrapper":"ContactInfo_wrapper__55M2M","main-info":"ContactInfo_main-info__-erJt","bonus-info":"ContactInfo_bonus-info__wEwpw"};